import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: '#1C2541',
    display: 'flex',
    width: '100%',
  },
  flexItemRight: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexGrow: 1,
  },
  pointPerson: {
    width: '100%',
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(-1),
    marginBottom: theme.spacing(3),
  },
  estateName: {
    color: '#FFFFFF',
    padding: theme.spacing(2),
    fontSize: '38px',
  },
  button: {
    backgroundColor: '#5ED1F0',
    color: '#1C2541',
    paddingLeft: theme.spacing(2.5),
    paddingRight: theme.spacing(2.5),
    height: theme.spacing(5),
    margin: theme.spacing(4),
    borderRadius: 25,
  },
  shareIcon: {
    marginTop: theme.spacing(4.5),
    marginRight: theme.spacing(6),
    color: '#FFFFFF',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  pointPersonSelection: {
    backgroundColor: '#FFFFFF',
    borderRadius: 5,
    padding: theme.spacing(0.6),
  },
  pointPersonDisplay: {
    padding: theme.spacing(0.5),
    borderRadius: 25,
    backgroundColor: '#FFFFFF',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  tabSection: {
    display: 'flex',
    backgroundColor: '#1C2541',
    borderColor: 'divider',
    '& .MuiTabs-indicator': { backgroundColor: '#5ED1F0' },
  },
  tab: {
    flexGrow: 1,
    color: '#FFFFFF',
    fontWeight: 'bold',
    '& .MuiTabs-indicator': {
      color: '#FFFFFF',
    },
    '&.Mui-selected': {
      color: '#5ED1F0',
    },
  },
  tabBox: {
    width: '100%',
  },
  tabContent: {
    maxWidth: '100%',
    overflowX: 'hidden',
  },
  estateDashboardWrapper: {
    width: '100%',
    flex: 1,
  },
  estateVaultWrapper: {
    width: '100%',
    flex: 1,
    '& [class*="parentContainer"]': {
      paddingTop: 0,
      padding: theme.spacing(2),
    },
  },
  estateBalanceSheetWrapper: {
    width: '100%',
    '& [class*="container"]': {
      padding: theme.spacing(2),
    },
  },
  estateResultsPageWrapper: {
    width: '100%',
    '& [class*="parentContainer"]': {
      marginTop: 0,
      padding: theme.spacing(2),
    },
  },
  main: {
    top: 0,
    left: 0,
    display: 'flex',
    width: '100%',
    position: 'absolute',
    height: '100%',
  },
  right: {
    position: 'relative',
    width: '100%',
    flexGrow: 2,
    height: '100%',
    overflow: 'auto',
  },
  header: {
    position: 'relative',
    top: 0,
    zIndex: 100,
  },
  progressBar: {
    color: '#FFFFFF',
    paddingLeft: '10%',
    paddingRight: '10%',
    paddingBottom: theme.spacing(3),
    backgroundColor: '#1C2541',
    justifyContent: 'center',
    alignItems: 'center',
    '& .MuiLinearProgress-root': {
      height: theme.spacing(1.5),
      borderRadius: 25,
      '& .MuiLinearProgress-bar': {
        backgroundColor: '#D351E1', // Filled part color (Green)
      },
    },
  },
  mainContainer: {
    height: '100vh',
    overflow: 'hidden',
    '& > [class^="makeStyles-container-"] > [class^="makeStyles-content-"]': {
      minHeight: 0,
    },
  },
}));
